import { type InitFlowComponent, isValidLocale, useLocale } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useEffect } from 'react';

/**
 * It sets up the Locale for the web app in the Authenticated flow
 * @param {() => void} next next callback
 * @param {ReactNode} fallback fallback component
 * @returns The fallback component
 */
export const LocaleSetupFlow: InitFlowComponent = ({ fallback, next }) => {
	const { searchParams } = useRouter();
	const locale = searchParams.get('locale') || '';
	const { setLocale } = useLocale();

	useEffect(() => {
		if (locale && isValidLocale(locale)) {
			setLocale(locale);
		}

		next();
	}, [locale]);

	return fallback;
};
